module.exports = __webpack_public_path__ + "static/img/kf_cloud_00006.b86ce20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00006.jpg
// module id = 177
// module chunks = 1